"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RTGDialogActions = exports.RTGDialogContent = exports.RTGDialogTitle = exports.RTGDialog = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      textAlign: 'center',
      padding: theme.spacing(1.6)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  };
};

var RTGDialogTitle = (0, _styles.withStyles)(styles)(function (props) {
  var children = props.children,
      classes = props.classes,
      onClose = props.onClose,
      _props$hideCloseButto = props.hideCloseButton,
      hideCloseButton = _props$hideCloseButto === void 0 ? false : _props$hideCloseButto;
  return /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    disableTypography: true,
    className: classes.root
  }, children, !hideCloseButton && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)));
});
exports.RTGDialogTitle = RTGDialogTitle;
var RTGDialogContent = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(2),
      borderTop: '2px solid rgba(0, 0, 0, 0.12)',
      borderBottom: '0px'
    }
  };
})(_DialogContent.default);
exports.RTGDialogContent = RTGDialogContent;
var RTGDialogActions = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      margin: 0,
      paddingBottom: 20,
      justifyContent: 'center',
      padding: theme.spacing(1)
    }
  };
})(_DialogActions.default);
exports.RTGDialogActions = RTGDialogActions;

var RTGDialog = function RTGDialog(props) {
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, _extends({}, props, {
    PaperProps: {
      style: {
        borderRadius: 0
      }
    }
  }));
};

exports.RTGDialog = RTGDialog;
RTGDialog.propTypes = {
  open: _propTypes.default.bool,
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  onClose: _propTypes.default.func
};
RTGDialog.defaultProps = {
  open: false,
  maxWidth: 'lg',
  onClose: function onClose() {}
};